import { useState, useEffect } from 'react'
import { TIMER_DURATION } from '../config.js'
import TimerBar from './TimerBar.jsx'
import TimerFlip from './TimerFlip.jsx'
import ProgressBar from './ProgressBar.jsx'

const RIGHT_REVEAL_DELAY = 1500
const WRONG_REVEAL_DELAY = 2000

export default function GameScreen({ question, questionIndex, total, results, onAnswer }) {
  const [selected, setSelected] = useState(null)
  const [timedOut, setTimedOut] = useState(false)
  const [timerKey, setTimerKey] = useState(0)

  useEffect(() => {
    setSelected(null)
    setTimedOut(false)
    setTimerKey(k => k + 1)
  }, [questionIndex])

  const handleSelect = (option) => {
    if (selected || timedOut) return
    setSelected(option)
    if (option.correct) {
      new Audio('./right.wav').play()
      navigator.vibrate?.(80)
    } else {
      new Audio('./wrong.wav').play()
      navigator.vibrate?.([100, 50, 100])
    }
    onAnswer(option.correct)  // ← immédiat
  }

  const handleTimeout = () => {
    if (selected || timedOut) return
    setTimedOut(true)
    new Audio('./wrong.wav').play()
    navigator.vibrate?.([100, 50, 100])
    onAnswer(false)  // ← immédiat
}

  const isLocked = !!selected || timedOut

  return (
    <>
      <TimerBar
        key={timerKey}
        duration={TIMER_DURATION}
        running={!isLocked}
      />
      <div className="screen game-screen">
        <ProgressBar results={results} total={total} />
        <div className="quiz-card">
          <TimerFlip
            key={timerKey}
            duration={TIMER_DURATION}
            running={!isLocked}
            onTimeout={handleTimeout}
          />
          <div className="image-container">
            <img
              src={`./${question.image}`}
              alt="Cityscape"
              className="quiz-image"
              style={{ width: '100%', maxWidth: '800px' }}
            />
          </div>
          <div className="options-container">
            {question.options.map((opt, i) => {
              let statusClass = ''
              if (isLocked) {
                if (opt.correct) statusClass = 'correct'
                else if (selected && opt === selected) statusClass = 'incorrect'
                else statusClass = 'unselected-wrong'
              }
              return (
                <button
                  key={i}
                  onClick={() => handleSelect(opt)}
                  className={`option-btn ${statusClass}`}
                  disabled={isLocked}
                >
                  {opt.label}
                </button>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}